import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import { Typography, Stack, CircularProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    backgroundColor: "transparent",
  },
  newPosOfDialog: {
    padding: 32,
    width: 328,
    height: 263,
    backgroundColor: "#FFFFFF",
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 15,
  },
}));

export interface LoggingOutDialogProps {
  open: boolean;
}

export const LoggingOutDialog = (props: LoggingOutDialogProps) => {
  const classes = useStyles();
  const { open } = props;

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        classes={{
          paper: classes.newPosOfDialog,
        }}
        onClose={() => {}}
        aria-labelledby="session-ending-dialog"
        open={open}>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ height: "100%", width: "100%" }}>
          <CircularProgress sx={{ marginTop: "32px" }} />
          <Typography variant="body2" sx={{ marginTop: "24px" }}>
            Your session has ended...
          </Typography>
        </Stack>
      </Dialog>
    </>
  );
};
